<template>
  <div style="display: contents;">
    <b-row>
      <b-col md="7">
        <b-card>
          <h5 class="package-title">Detalii generale rezervare <span class="float-right font-weight-bold px-2 ">nr. {{ booking.id }}</span></h5>
            <table class="table table-striped border">
                <tr>
                  <td><b> Data rezervare:</b> {{ getDate(booking.booking_date, 'DD-MM-YYYY') }}</td>
                  <td><b> Suma Totala:</b> {{ booking.currency }} {{ bookingTotal }}
                    <b-icon :icon="collapsed ? 'plus-square': 'dash-square'" scale="1.1" @click="collapsed = !collapsed" variant="primary" class="float-right"/>
                  </td>
                </tr>
                <tr>
                  <td><b> Numar rezervare:</b> {{ booking.id}}</td>
                  <td>
                    <span v-if="!collapsed">
                      <b> Comision:</b> {{ booking.currency }} {{ booking.commission }}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td><b> Status rezervare:</b>
                    &nbsp; <span class="text-danger" v-if="booking.status === 'cancelled' "><b>{{ booking.status }}</b></span>
                           <span class="text-warning" v-else-if="booking.status === 'option' "><b>{{ booking.status }}</b></span>
                           <span class="text-success" v-else-if="booking.status === 'confirmed'"><b>{{ booking.status }}</b></span>
                           <span class="text-info" v-else><b>{{ booking.status }}</b></span>
                  </td>
                  <td>
                    <span v-if="!collapsed">
                      <b> Total de plata:</b> {{ booking.currency }} {{ bookingTotalDue }}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td><b> Destinatie:</b> {{ booking.destination }}</td>
                  <td>
                    <span v-if="!collapsed">
                      <b> Incasat:</b> {{ booking.currency }} {{ booking.paid }}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td><b> Agent:</b> {{ booking.user }}</td>
                  <td>
                    <span v-if="!collapsed">
                      <b> Rest de plata:</b> {{ booking.currency }} {{ bookingUnpaid }}
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>
                    <b> Agentie:</b> {{ userData.companyName }}
                  </td>
                  <td>
                     <span v-if="!collapsed">
                      <b>Facturi:</b>
                      <span v-if="!invoices.length"> n/a</span>
                      <b-btn @click="downloadInvoice(invoice)" class="ml-2" v-for="invoice in invoices" :key="invoice.id" variant="link" size="sm" v-b-tooltip.hover title="Download factura">
                        <b-icon icon="download" scale="0.9"/> {{ invoice.number}}
                      </b-btn><br/>
                    </span>
                  </td>
                </tr>
                <tr v-if="!collapsed">
                  <td><b> Scadentar:</b> </td>
                  <td>
                    <span v-for="(d,dIndex) in booking.due_dates" :key="'dueDate'+dIndex">{{ booking.currency }} {{ d.amount }} pana la {{ d.date }}<br /></span>
                    diferenta pana la {{ booking.balance_due_date }}
                  </td>
                </tr>
            </table>
            <b-card class="p-2" no-body>
              <b>Note agent:</b>
              <span style="white-space: pre-line;" v-for="(note, index) in booking.notes" :key="index">{{note.text}}</span>
            </b-card>
        </b-card>
      </b-col>
      <b-col md="5" class="my-3 my-md-0">
        <b-card class="mb-2">
          <h5 class="package-title">Pasageri</h5>
          <table class="table table-striped table-sm border">
            <tbody>
              <tr v-for="(pax, paxIndex) in booking.pax" :key="paxIndex">
                <td><span class="small text-">{{pax.title + ' ' + pax.fname + ' ' + pax.lname}}</span>
                <span class="badge float-right"> {{ pax.ageGroup }} / {{ getDate(pax.bdate) }} </span></td>
              </tr>
            </tbody>
          </table>
        </b-card>
        <b-card>
          <h5 class="package-title">Fisiere</h5>
        <table class="table table-striped table-sm border">
          <tbody>
            <tr v-for="(file, fileIndex) in booking.attachments" :key="fileIndex">
              <td colspan="2">{{ file.title }}</td>
            </tr>
            <tr>
              <td>
                <b-form-file
                size="sm"
                  v-model="file"
                  accept=".pdf"
                  placeholder="Alege un fisier PDF aici..."
                  drop-placeholder="Lasa un fisier PDF aici..."
                ></b-form-file>
              </td>
              <td>
                <b-button @click="onUploadClick()" variant="primary" size="sm">Trimite</b-button>
              </td>
            </tr>
          </tbody>
        </table>
        </b-card>
      </b-col>
    </b-row>
    <b-row class="my-3">
      <b-col>
        <hr />
      </b-col>
    </b-row>
    <b-row v-for="item in booking.items" :key="'item' + item.id">
      <b-col>
        <PackageItem :item="item" v-if="item.type === 'sd_package'" />
        <FlightItem :item="item" v-else-if="item.type === 'flight'" />
        <TransferItem :item="item" v-else-if="item.type === 'transfer'" />
        <HotelItem :item="item" v-else-if="item.type === 'hotel'" />
        <InsuranceItem :item="item" v-else-if="item.type === 'insurance'" />
        <div v-else>
          <h6 class="booking-details-title">{{ item.label }}</h6>
          <b-card bg-variant="light">
            <b-card-text style="white-space: pre-line;">
              {{ item.description }}
            </b-card-text>
          </b-card>
        </div>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <hr>
      </b-col>
      <b-col>
        <b-button variant="warning" size="sm" class="float-right" @click="$router.push({ name: 'Private/Bookings/Search' })"><b-icon icon="chevron-left" />Inapoi la rezervari</b-button>
      </b-col>
    </b-row>
    <!-- {{ booking.id }} -->
  </div>
</template>

<script>
import moment from 'moment'
import http from 'b2b-common/vue-config/axios'

import { authApiURL } from 'b2b-common/utils'
import { getInvoice, downloadPdf } from 'b2b-common/services/api/document'

import authMixin from '@/app/private/shared/mixins/auth'
import viewMixin from '../../shared/mixins/search_views'

import PackageItem from './package_item_info'
import TransferItem from './transfer_item_info'
import FlightItem from './flight_item_info'
import HotelItem from './hotel_item_info'
import InsuranceItem from './insurance_item_info'

export default {
  name: 'bookingDetails',
  props: ['booking'],
  mixins: [authMixin, viewMixin],
  components: { PackageItem, TransferItem, FlightItem, InsuranceItem, HotelItem },
  data () {
    return {
      file: null,
      collapsed: false
    }
  },
  computed: {
    invoices () {
      return this.booking.invoices.filter(invoice => !invoice.is_cancelled)
    },
    bookingTotal () {
      const n = parseFloat(this.booking.gross) + parseFloat(this.booking.tax)
      return Math.ceil(n * 100) / 100
    },
    bookingTotalDue () {
      const n = parseFloat(this.booking.gross) + parseFloat(this.booking.tax) - parseFloat(this.booking.commission)
      return Math.ceil(n * 100) / 100
    },
    bookingUnpaid () {
      const n = parseFloat(this.booking.gross) + parseFloat(this.booking.tax) - parseFloat(this.booking.commission) - parseFloat(this.booking.paid)
      return Math.ceil(n * 100) / 100
    }
  },
  methods: {
    getDate (date) {
      return moment(date).format('DD-MM-YYYY')
    },
    async onUploadClick () {
      const formData = new FormData()
      formData.append('file', this.file)
      const res = await http.post(authApiURL,
        formData,
        {
          params: {
            action: 'attachBookingFile',
            id: this.booking.id
          },
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      )
      this.booking.attachments.push(res.data)
      return res.data
    },
    async downloadInvoice (invoice) {
      const pdfData = await getInvoice({ bookingId: this.booking.id, invoiceId: invoice.id })
      const fileName = 'factura_' + invoice.number + '.pdf'
      downloadPdf({ pdfData: pdfData.pdf, fileName })
    }
  }
}
</script>
